import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=18b3331a&"
import script from "./AdminDashboard.vue?vue&type=script&lang=js&"
export * from "./AdminDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b3331a')) {
      api.createRecord('18b3331a', component.options)
    } else {
      api.reload('18b3331a', component.options)
    }
    module.hot.accept("./AdminDashboard.vue?vue&type=template&id=18b3331a&", function () {
      api.rerender('18b3331a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/AdminDashboard.vue"
export default component.exports